export default __webpack_public_path__ + "static/media/1966.b37fade0.png";